import React, { useState } from "react";
import CardContenido from "./CardContenido";
import arrow_up from "../../../../assets/vw/svg/arrow-up.svg";
import arrow_down from "../../../../assets/vw/svg/arrow-down.svg";

const SelectCard = ({
    infoCard,
    handleArchivar = () => {},
    index,
    selectCheck,
    aplicaciones,
    currentActive,
    setCurrentActive,
    contextos
}) => {

    const [showContent, setShowContent] = useState(false);

    const getApp = (idApp) => {
        if (idApp) {
            const objApp = aplicaciones.find((app) => app.idApp === idApp);
            return objApp.nombre;
        } else return "-";
    };

    function localDateTimeToUTC(date) {
        const fechaLocal = new Date(date);

        // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
        const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

        return fechaUTC;
    }
    return (
        <div className={"select-card-container"}>
            <div className={"select-card-header d-flex justify-content-between"}>
                <div className={"d-flex"}>
                    <div className="ms-auto align-self-center">
                        <input
                            type="checkbox"
                            className="checkbox-round"
                            id={"select-" + index}
                            value={infoCard.original.sesionId}
                            onChange={(e) => selectCheck(e, index)}
                        />
                    </div>
                    <div className="container_id bold ml-3 mr-2 font-weight-bolder">
                        {infoCard.original.sesionId}
                    </div>
                    <div className="select-card-title-one-word font-weight-bolder">
                        {infoCard.original.correo}
                    </div>
                </div>
                <div>
                    <button
                        className={"button_icon-vw select-card-arrow"}
                        onClick={() => {
                            setShowContent(prevState => !prevState);
                            setCurrentActive({id: index});
                        }}
                    >
                        {
                            (showContent && (currentActive.id !== null && (currentActive.id === index)) ) ? (
                                <img
                                    src={arrow_up}
                                    alt="arrow-up"
                                />
                            ): (
                                <img
                                    src={arrow_down}
                                    alt="arrow-down"
                                />
                            )
                        }
                    </button>
                </div>

            </div>
            {
                (showContent && (currentActive.id !== null && (currentActive.id === index)) ) && (
                    <CardContenido 
                        infoCard={infoCard}
                        handleArchivar={handleArchivar}
                        id={index}
                        setShowContent={setShowContent}
                        getApp={getApp}
                        localDateTimeToUTC={localDateTimeToUTC}
                        contextos={contextos}
                    />
                )
            }
        </div>
    );
}

export default SelectCard;